'use client'

import { useServerInsertedHTML } from 'next/navigation'
import { ReactNode, useState } from 'react'
import { ServerStyleSheet, StyleSheetManager } from 'styled-components'

interface IConfigStyledComponentsProviderProps {
  children: ReactNode
}

/**
 * Registry SSR de styled-components para App Router: recolecta los estilos
 * generados en el servidor y los inyecta en el HTML streameado, evitando
 * el flash sin estilos en el primer paint (emotion lo hacía zero-config)
 */
const ConfigStyledComponentsProvider: React.FC<IConfigStyledComponentsProviderProps> = ({ children }) => {
  const [styledComponentsStyleSheet] = useState(() => new ServerStyleSheet())

  useServerInsertedHTML(() => {
    const styles = styledComponentsStyleSheet.getStyleElement()

    styledComponentsStyleSheet.instance.clearTag()

    return <>{styles}</>
  })

  if (typeof window !== 'undefined') {
    return <>{children}</>
  }

  return <StyleSheetManager sheet={styledComponentsStyleSheet.instance}>{children}</StyleSheetManager>
}

export default ConfigStyledComponentsProvider
